import { encrypt, decrypt } from "./cryptoUtil";
import { tracker } from "./openreplay";

const languifyIsCredentials = Symbol("languifyIsCredentials");

class Session {
  userId = "";
  user = ""
  accessToken = "";
  redirectUrl = null;
  accessTokenExpiry = Date.now();
  refreshToken = "";
  refreshTokenExpiry = Date.now();

  _setUser(user) {
    this.userId = user._id;
    this.user = user;

    localStorage.setItem('guestId', this.userId);

    if (process.env.REACT_APP_STAGE === 'prod' &&
      process.env.NODE_ENV === 'production') {
      if (this.isLoggedIn()) {
        tracker?.setUserID(this.user?.email);
        tracker?.setMetadata('registered', 'true');
      } else {
        tracker?.setUserID(this.userId);
        tracker?.setMetadata('registered', 'false');
      }
    }
  }

  _unsetUser() {
    this.userId = "";
    this.user = null;
  }

  onCreateSession({ user, tokens, guest = false, redirectUrl = null }) {
    this._setUser(user);
    this.accessToken = tokens.accessToken;
    this.accessTokenExpiry = new Date(tokens.accessExpireAt).getTime();
    this.redirectUrl = redirectUrl
    this.refreshToken = tokens.refreshToken;

    this.refreshTokenExpiry = new Date(tokens.refreshExpireAt).getTime();
    localStorage.setItem("languifyIsLoggedIn", (!guest).toString());
    localStorage.setItem("languifyRefreshTokenExpiry", this.refreshTokenExpiry.toString());
    localStorage.setItem("languifyRefreshToken", this.refreshToken);
  }

  onRestoreSession({ accessToken, accessExpireAt, user, guest = false }) {
    this._setUser(user);
    this.accessToken = accessToken;
    this.accessTokenExpiry = new Date(accessExpireAt).getTime();
    localStorage.setItem("languifyIsLoggedIn", (!guest).toString());
  }

  clearSession() {
    try {
      this.accessToken = "";
      this.accessTokenExpiry = Date.now();
      this.refreshToken = "";
      this.redirectUrl = null;
      this.refreshTokenExpiry = Date.now();
      localStorage.removeItem("languifyIsLoggedIn", false.toString());
      localStorage.removeItem("languifyRefreshTokenExpiry");
      localStorage.removeItem("languifyRefreshToken");
      this.unRememberMe();
      this._unsetUser();
    } catch (error) {
      console.error(error);
    }
  }

  isLoggedIn() {
    return JSON.parse(localStorage.getItem("languifyIsLoggedIn"));
  }

  isRemembered() {
    if (languifyIsCredentials.description) {
      const credentialsRemembered = localStorage.getItem(languifyIsCredentials.description);
      return Boolean(credentialsRemembered) ? decrypt(credentialsRemembered) : false;
    } else return false;
  }

  rememberMe({ phone, password }) {
    if (languifyIsCredentials.description)
      localStorage.setItem(languifyIsCredentials.description, encrypt({ phone, password }));
  }

  unRememberMe() {
    if (languifyIsCredentials.description)
      localStorage.removeItem(languifyIsCredentials.description);
  }
}

export default new Session();